import type { LocaleDict } from '../index';

export const lt: LocaleDict = {
  // ── App shell ──
  app: {
    connectionLost: 'Nutrūko ryšys — Bandoma prisijungti iš naujo...',
  },

  // ── Spectra ──
  spectra: {
    'hot-cold': { left: 'Karšta', right: 'Šalta' },
    'big-small': { left: 'Didelis', right: 'Mažas' },
    'loud-quiet': { left: 'Garsus', right: 'Tylus' },
    'fast-slow': { left: 'Greitas', right: 'Lėtas' },
    'heavy-light': { left: 'Sunkus', right: 'Lengvas' },
    'bright-dim': { left: 'Ryškus', right: 'Blausus' },
    'wet-dry': { left: 'Šlapias', right: 'Sausas' },
    'hard-soft': { left: 'Kietas', right: 'Minkštas' },
    'sharp-dull': { left: 'Aštrus', right: 'Bukas' },
    'sweet-sour': { left: 'Saldus', right: 'Rūgštus' },
    'rough-smooth': { left: 'Šiurkštus', right: 'Lygus' },
    'deep-shallow': { left: 'Gilus', right: 'Seklus' },
    'wide-narrow': { left: 'Platus', right: 'Siauras' },
    'thick-thin': { left: 'Storas', right: 'Plonas' },
    'full-empty': { left: 'Pilnas', right: 'Tuščias' },
    'old-young': { left: 'Senas', right: 'Jaunas' },
    'rich-poor': { left: 'Turtingas', right: 'Vargšas' },
    'happy-sad': { left: 'Laimingas', right: 'Liūdnas' },
    'calm-excited': { left: 'Ramus', right: 'Susijaudinęs' },
    'simple-complex': { left: 'Paprastas', right: 'Sudėtingas' },
    'useless-essential': { left: 'Nenaudingas', right: 'Būtinas' },
    'dangerous-safe': { left: 'Pavojingas', right: 'Saugus' },
    'cheap-expensive': { left: 'Pigus', right: 'Brangus' },
    'weak-strong': { left: 'Silpnas', right: 'Stiprus' },
    'ugly-beautiful': { left: 'Bjaurus', right: 'Gražus' },
    'stupid-smart': { left: 'Kvailas', right: 'Protingas' },
    'boring-interesting': { left: 'Nuobodus', right: 'Įdomus' },
    'fake-real': { left: 'Netikras', right: 'Tikras' },
    'common-rare': { left: 'Įprastas', right: 'Retas' },
    'bad-good': { left: 'Blogas', right: 'Geras' },
    'easy-difficult': { left: 'Lengvas', right: 'Sunkus' },
    'soft-loud': { left: 'Švelnus', right: 'Garsus' },
    'dark-light': { left: 'Tamsus', right: 'Šviesus' },
    'low-high': { left: 'Žemas', right: 'Aukštas' },
    'short-tall': { left: 'Žemas', right: 'Aukštas' },
    'stale-fresh': { left: 'Pasenęs', right: 'Šviežias' },
    'vague-precise': { left: 'Neaiškus', right: 'Tikslus' },
    'passionate-indifferent': { left: 'Aistringas', right: 'Abejingas' },
    'bitter-savory': { left: 'Kartus', right: 'Skanus' },
    'salty-spicy': { left: 'Sūrus', right: 'Aštrus' },
    'cold-warm': { left: 'Šaltas', right: 'Šiltas' },
    'dull-shiny': { left: 'Blausus', right: 'Blizgantis' },
    'fragile-durable': { left: 'Trapus', right: 'Patvarus' },
    'rigid-flexible': { left: 'Kietas', right: 'Lankstus' },
    'chaotic-orderly': { left: 'Chaotiškas', right: 'Tvarkingas' },
    'messy-tidy': { left: 'Netvarkingas', right: 'Tvarkingas' },
    'noisy-peaceful': { left: 'Triukšmingas', right: 'Ramus' },
    'busy-slow': { left: 'Užimtas', right: 'Lėtas' },
    'risky-certain': { left: 'Rizikingas', right: 'Tikras' },
    'unfair-just': { left: 'Nesąžiningas', right: 'Teisingas' },
    'cruel-kind': { left: 'Žiaurus', right: 'Malonus' },
    'selfish-generous': { left: 'Savanaudis', right: 'Dosnus' },
    'cowardly-brave': { left: 'Bailus', right: 'Drąsus' },
    'lazy-ambitious': { left: 'Tingus', right: 'Ambicingas' },
    'shy-outgoing': { left: 'Drovus', right: 'Atviras' },
    'gloomy-cheerful': { left: 'Niūrus', right: 'Linksmas' },
    'serious-silly': { left: 'Rimtas', right: 'Kvailas' },
    'tense-relaxed': { left: 'Įtemptas', right: 'Atsipalaidavęs' },
    'urban-rural': { left: 'Miesto', right: 'Kaimo' },
    'modern-ancient': { left: 'Modernus', right: 'Senovinis' },
  },

  // ── Landing screen ──
  landing: {
    title: 'Bangos',
    subtitle: 'Intuicijos ir suvokimo žaidimas',
    createRoom: 'Sukurti kambarį',
    joinRoom: 'Prisijungti prie kambario',
  },

  // ── Create Room screen ──
  createRoom: {
    title: 'Sukurti kambarį',
    back: 'Atgal',
    createRoom: 'Sukurti kambarį',
  },

  // ── Join Room screen ──
  joinRoom: {
    title: 'Prisijungti prie kambario',
    roomCodeLabel: 'Kambario kodas',
    roomCodePlaceholder: 'pvz. ABC123',
    roomCodeHint: 'Įveskite 6 simbolių kambario kodą',
    joinAsSpectator: 'Prisijungti kaip stebėtojas',
    back: 'Atgal',
    joinRoom: 'Prisijungti',
  },

  // ── Display Name input ──
  displayName: {
    label: 'Jūsų vardas',
    placeholder: 'Įveskite savo vardą',
    errorRequired: 'Vardas yra privalomas',
    errorTooShort: 'Vardas turi būti bent 2 simbolių ilgio',
    errorTooLong: 'Vardas turi būti ne ilgesnis nei 20 simbolių',
  },

  // ── Room Code validation ──
  roomCode: {
    errorRequired: 'Kambario kodas yra privalomas',
    errorLength: 'Kambario kodas turi būti tiksliai 6 simbolių',
    errorInvalidChars: 'Kambario kodas turi netinkamų simbolių',
  },

  // ── Error banner ──
  errorBanner: {
    dismissAriaLabel: 'Pašalinti klaidą',
  },

  // ── Lobby screen ──
  lobby: {
    roomCodeHeading: 'Kambario kodas',
    copyCode: '📋 Kopijuoti kodą',
    copyLink: '🔗 Kopijuoti nuorodą',
    copied: '✓ Nukopijuota',
    shareHint: 'Pasidalinkite su draugais, kad jie prisijungtų prie žaidimo',
    blueTeam: 'Mėlyna komanda',
    redTeam: 'Raudona komanda',
    noPlayersYet: 'Dar nėra žaidėjų',
    disconnected: '(atsijungęs)',
    players: 'Žaidėjai',
    spectators: 'Stebėtojai',
    waitingPlayers: 'Laukiama dar {remaining} žaidėjo{plural}... (reikia bent 2 žaidėjų)',
    ready: '✅ Pasiruošęs',
    clickWhenReady: 'Spustelėkite, kai būsite pasiruošę',
    waitingForReady: 'Laukiama, kol visi žaidėjai bus pasiruošę...',
    startGame: 'Pradėti žaidimą',
    submitSpectrum: '✏️ Pasiūlyti savo spektrą',
    cancel: 'Atšaukti',
    spectrumFormDescription:
      'Sukurkite spektro porą su dviem priešingomis sąvokomis. Pasiūlyti spektrai gali pasirodyti būsimuose raunduose!',
    spectrumLeftPlaceholder: 'Kairė etiketė (pvz. Karšta)',
    spectrumRightPlaceholder: 'Dešinė etiketė (pvz. Šalta)',
    submitSpectrumBtn: 'Pateikti spektrą',
    leaveRoom: 'Išeiti iš kambario',
  },

  // ── In-game header ──
  gameHeader: {
    title: 'Bangos',
    round: 'Raundas',
    activeTeam: 'Aktyvi komanda',
    blueShort: '🔵 Mėlyna',
    redShort: '🔴 Raudona',
    helpTitle: 'Rodyti instrukciją',
    helpAriaLabel: 'Rodyti instrukciją',
    spectatorNotice: 'Jūs esate stebėtojas. Stebėkite žaidimo eigą!',
  },

  // ── Scoreboard ──
  scoreboard: {
    blue: 'Mėlyna',
    red: 'Raudona',
  },

  // ── Guessing slider ──
  guessingSlider: {
    position: 'Pozicija',
    confirmGuess: 'Patvirtinti spėjimą',
    waiting: 'Laukiama...',
    guessSubmitted: 'Spėjimas pateiktas {position} pozicijoje',
  },

  // ── Psychic view ──
  psychic: {
    spectrumTitle: 'Spektras',
    dialPosition: 'Rodyklės pozicija: {pos}',
    psychicNotice: 'Jūs esate aiškiaregys! Sugalvokite užuominą, susijusią su spektru.',
    cluePlaceholder: 'Įveskite užuominą (vienas žodis arba trumpa frazė)',
    submit: 'Pateikti',
    yourClue: 'Jūsų užuomina: {clue}',
    activeTeamGuessing: 'Aktyvi komanda nustatinėja savo spėjimą...',
    psychicBadge: 'Aiškiaregys',
  },

  // ── Guesser view ──
  guesser: {
    spectrumTitle: 'Spektras',
    psychicThinking: 'Aiškiaregys galvoja užuominą...',
    psychicsClue: 'Aiškiaregio užuomina: {clue}',
    guessSubmittedWaiting: 'Jūsų spėjimas pateiktas. Laukiama kitų komandos narių...',
    activeTeamGuessing: 'Aktyvi komanda nustatinėja savo spėjimą...',
  },

  // ── Reveal screen ──
  reveal: {
    title: '🎯 Raundas atskleistas!',
    readyForNext: 'Pasiruošęs kitam raundui',
    waitingForOthers: 'Laukiama kitų...',
    readyCount: '{ready}/{total} pasiruošę',
    spectrumTitle: 'Spektras',
    clue: 'Užuomina: {text}',
    yourGuess: 'Jūsų spėjimas',
    targetPosition: 'Tikslo pozicija',
    distance: 'Atstumas',
    pointsEarned: 'Pelnyti taškai',
  },

  // ── Game Over screen ──
  gameOver: {
    title: '🎮 Žaidimas baigtas!',
    blueWins: '🔵 Mėlyna komanda laimi!',
    redWins: '🔴 Raudona komanda laimi!',
    draw: '🤝 Lygiosios!',
    blueTeam: 'Mėlyna komanda',
    redTeam: 'Raudona komanda',
    roundRecap: '📋 Raundų apžvalga',
    round: 'Raundas {num}',
    clue: 'Užuomina',
    clueValue: 'Užuomina: {text}',
    targetPosition: 'Tikslo pozicija',
    guessPosition: 'Spėjimo pozicija',
    distance: 'Atstumas',
    points: 'Taškai',
    playAgain: 'Žaisti dar kartą',
  },

  // ── Onboarding ──
  onboarding: {
    skip: 'Praleisti',
    gotIt: 'Supratau!',
    back: '← Atgal',
    done: 'Baigta',
    next: 'Toliau →',
    step1Title: '🎯 Sveiki atvykę į Bangos!',
    step1P1:
      'Bangos yra intuicijos ir suvokimo žaidimas. Kiekviename raunde vienas žaidėjas tampa **Aiškiaregiu**, kuris mato slaptą taikinį spektro skalėje — o visi kiti bando atspėti, kur jis yra, remdamiesi viena užuomina.',
    step1P2:
      'Ši trumpa apžvalga paaiškins pagrindines taisykles. Ją galėsite atidaryti bet kada paspaudę **?** piktogramą.',
    step2Title: '🔮 Aiškiaregio vaidmuo',
    step2P1:
      'Kiekviename raunde atsitiktinai parenkamas vis kitas žaidėjas kaip **Aiškiaregys**. Tik Aiškiaregys mato **slaptą tikslo poziciją** spektro skalėje (pažymėtą geltonai šviečiančiu žymekliu).',
    step2P2:
      'Jūsų, kaip Aiškiaregio, tikslas yra sugalvoti užuominą, kuri užsimintų apie tikslo vietą — nebūdama nei per daug akivaizdi, nei per daug miglota.',
    step3Title: '💬 Užuominos pateikimas',
    step3P1:
      'Būdamas Aiškiaregiu, įvedate **vieną žodį arba trumpą frazę** (iki 50 simbolių), susijusią su rodomu spektru.',
    step3P2:
      'Pavyzdžiui, jei spektras yra _Karšta — Šalta_, o taikinys yra arčiau „Karšta“ pusės, galite pasakyti **"Vasara"** arba **"Saulė"**.',
    step3P3:
      'Paspauskite **Enter** arba spustelėkite **Pateikti**, kad išsiųstumėte savo užuominą.',
    step4Title: '🎚️ Spėjimo slankiklis',
    step4P1:
      'Spėjanti komanda mato užuominą ir diskutuoja, kur gali būti taikinys. Vienas žaidėjas iš aktyvios komandos naudoja **slankiklį**, kad pateiktų komandos spėjimą.',
    step4P2:
      '**Vilkite** žymeklį išilgai juostos arba **spustelėkite** bet kurioje juostos vietoje, kad nustatytumėte poziciją. Tada spustelėkite **Patvirtinti spėjimą**, kad užfiksuotumėte.',
    step5Title: '📊 Taškų skaičiavimas',
    step5P1:
      'Po spėjimo pateikimo taikinys atskleidžiamas. Taškai skiriami pagal tai, kaip arti spėjimas yra prie taikinio:',
    step5Li1: '**4 taškai** — ≤ 3 atstumas (puiku!)',
    step5Li2: '**3 taškai** — ≤ 8 atstumas',
    step5Li3: '**2 taškai** — ≤ 15 atstumas',
    step5Li4: '**1 taškas** — visa kita',
    step5P2:
      'Žaidimas trunka 8 raundus. Laimi komanda, surinkusi daugiausiai taškų pabaigoje!',
  },

  // ── PWA Install prompt ──
  installPrompt: {
    message: 'Įdiekite Bangos, kad patirtis būtų dar geresnė!',
    install: 'Įdiegti',
    notNow: 'Ne dabar',
  },
};
